export default __webpack_public_path__ + "static/media/schools_bg.8be37cbc.jpg";